module.exports = __webpack_public_path__ + "assets/img/search-ing.8cafee3d.png";